export default "__VITE_PUBLIC_ASSET__d775ebe3__"